enum RuleType {
  String,
  Boolean,
  Radio,
  Checkbox,
  Email,
  URL,
  Number,
  File,
  Any,
}

export default RuleType;
